import { render, staticRenderFns } from "./BookingPositionAcceptedList.vue?vue&type=template&id=45ccbd3b&"
import script from "./BookingPositionAcceptedList.vue?vue&type=script&lang=js&"
export * from "./BookingPositionAcceptedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports